import React, {
    useState, 
    // useEffect 
} from 'react';
import styles from './TotalReserved.module.css';

// import { Bar } from 'react-chartjs-2';
// import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';

import { 
    Bar, 
    //Line 
} from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  LineController, // Import LineController
} from 'chart.js';

import { getHodlersForPublicKey } from '../utils/deso-api';

import { avatarUrl } from '../utils/helper';

// import SummarySnippet from './SummarySnippet'; // Import the new component

import { useFundingRound } from '../context/FundingRoundContext'; // Import the hook

const Web3Utils = require('web3-utils');

// Register the components we will use from Chart.js
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    LineController // Register LineController
);

const TotalReserved = () => {
    const [hodlersData, setHodlersData] = useState(null);
    const [preparedData, setPreparedData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [requestError, setRequestError] = useState(null);

    const { data } = useFundingRound(); // Use the context

    const exportHodlersDataAsJSON = () => {
        if (!hodlersData) {
            console.warn("No data to export!");
            return;
        }
        
        const dataStr = JSON.stringify(hodlersData, null, 2);
        const blob = new Blob([dataStr], { type: "application/json" });
        const url = URL.createObjectURL(blob);
    
        const link = document.createElement("a");
        link.href = url;
        link.download = "FocusHoldersRawData.json";
        link.click();
    
        URL.revokeObjectURL(url);
    };
    
    const exportTableDataAsCSV = () => {
        if (preparedData.length === 0) {
            console.warn("No data to export!");
            return;
        }

        const header = ["#", "Username / PublicKey", "Tokens Reserved", "Percentage of Total (%)", "USD Value", "User Link"];
        const rows = preparedData.map(row => [
            row.index,
            row.usernameOrPublicKey,
            row.tokensReserved,
            row.percentageOfTotal,
            row.usdValue,
            row.profileLink,
        ]);

        const csvContent = [header, ...rows].map(row => row.join(",")).join("\n");

        const blob = new Blob([csvContent], { type: "text/csv" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = "hodlersTableData.csv";
        link.click();

        URL.revokeObjectURL(url);
    };
    
    const prepareTableData = (hodlersData) => {
        if (!hodlersData) return [];

        const totalReservedTokensNum = hodlersData
        ? hodlersData.reduce((total, hodler) => total + parseFloat(hexNanosToUnitString(hodler.BalanceNanosUint256)), 0)
        : 0;
    
        const totalUSD = data 
        ? data.AmountRaisedUSDCents / 100
        : 0;        
        
        console.log("hodlersData: ", hodlersData)

        return hodlersData.map((hodler, index) => {
            const tokens = parseFloat(hexNanosToUnitString(hodler.BalanceNanosUint256));
            const percentageOfTotal = ((tokens / totalReservedTokensNum) * 100).toFixed(2);
            const usdValue = totalUSD > 0 ? ((totalUSD * percentageOfTotal) / 100).toFixed(2) : 0;

            return {
                index: index + 1,
                usernameOrPublicKey: hodler.ProfileEntryResponse?.Username || hodler.HODLerPublicKeyBase58Check,
                // tokensReserved: tokens.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                tokensReserved: tokens,
                //percentageOfTotal: `${percentageOfTotal}%`,
                percentageOfTotal: percentageOfTotal,
                // usdValue: parseFloat(usdValue).toLocaleString('en-US', { style: 'currency', currency: 'USD' }),
                usdValue: parseFloat(usdValue),
                profileLink: `https://wallet.deso.com/?tab=activity&user=${hodler.ProfileEntryResponse?.Username || hodler.HODLerPublicKeyBase58Check}`,
                avatar: avatarUrl(hodler?.ProfileEntryResponse),
            };
        });
    };    

    const fetchHodlers = async () => {

        try {
            const settings = {
                FetchAll: true,
                IsDAOCoin: true,
                Username: "FOCUS_reservations"
            };

            setIsLoading(true);
            setRequestError(null);

            const result = await getHodlersForPublicKey(settings);

            let { error, Hodlers } = result

            if(error){
                console.log("error: ", error)
                setHodlersData(null)
                setRequestError(error);
            }

            // if(Hodlers){
            //     setHodlersData(Hodlers);
            //     // After fetching and setting hodlersData:
            //     const preparedData = prepareTableData(Hodlers)
            //     console.log(preparedData)
            //     setPreparedData(preparedData);
            // }

            if (Hodlers) {
                // Convert and sort Hodlers by tokens in descending order
                const sortedHodlers = Hodlers.sort((a, b) => {
                    const tokensA = parseFloat(hexNanosToUnitString(a.BalanceNanosUint256));
                    const tokensB = parseFloat(hexNanosToUnitString(b.BalanceNanosUint256));
                    return tokensB - tokensA; // Descending order
                });
            
                // Set hodlersData with sorted data
                setHodlersData(sortedHodlers);
            
                // Prepare table data with sorted hodlers
                const preparedData = prepareTableData(sortedHodlers);
                console.log(preparedData);
                setPreparedData(preparedData);
            }         

            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            setRequestError(error);
            setIsLoading(false);
        }
    };
   
    const hexNanosToUnitString = (hexNanos) => {
        const result = Web3Utils.fromWei(hexNanos, 'ether').toString();
        const number = parseFloat(result);
        return number
    }

    const totalHolders = hodlersData ? hodlersData.length.toLocaleString('en-US') : '0';
    const totalReservedTokens = hodlersData ? hodlersData.reduce((total, hodler) => total + parseFloat(hexNanosToUnitString(hodler.BalanceNanosUint256)), 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00';

    // Function to prepare data for the Pareto chart
    const prepareParetoChartData = () => {
        const sortedData = hodlersData.sort((a, b) => 
          parseFloat(Web3Utils.fromWei(b.BalanceNanosUint256, 'ether')) - 
          parseFloat(Web3Utils.fromWei(a.BalanceNanosUint256, 'ether'))
        );

        // const labels = sortedData.map((hodler, index) => 
        //   hodler.ProfileEntryResponse?.Username || `Holder #${index + 1}`
        // );

        const labels = sortedData.map((hodler, index) => {
            const username = hodler.ProfileEntryResponse?.Username;
            const publicKey = hodler.HODLerPublicKeyBase58Check;
            return username ? `#${index + 1} ${username}` : `#${index + 1} ${publicKey}`;
        });

        const tokenAmounts = sortedData.map(hodler => 
          parseFloat(Web3Utils.fromWei(hodler.BalanceNanosUint256, 'ether'))
        );

        const cumulativeSum = ((sum) => value => sum += value)(0);
        const cumulativeTokenAmounts = tokenAmounts.map(cumulativeSum);
        const totalTokens = cumulativeTokenAmounts[cumulativeTokenAmounts.length - 1];
        const cumulativePercentages = cumulativeTokenAmounts.map(sum => (sum / totalTokens) * 100);

        return {
            labels: labels,
            datasets: [
                {
                    label: 'Tokens Reserved',
                    data: tokenAmounts,
                    type: 'bar',
                    yAxisID: 'y',
                    backgroundColor: 'rgba(54, 162, 235, 0.6)'
                },
                {
                    label: 'Cumulative Percentage',
                    data: cumulativePercentages,
                    type: 'line',
                    yAxisID: 'y1',
                    borderColor: 'rgba(255, 99, 132, 1)',
                    borderWidth: 2, // Make the line thinner by reducing the borderWidth
                    pointRadius: 0, // Hide the points by default
                    pointHoverRadius: 5, // Show the points when hovered
                    backgroundColor: 'rgba(0, 0, 0, 0)',
                    fill: false
                }
            ]
        };
    };
    
    const paretoChartOptions = {
        responsive: true,
        interaction: {
            mode: 'index',
            intersect: false,
        },
        // interaction: {
        //     mode: 'nearest',
        //     intersect: true,
        //     axis: 'x'
        // },
        scales: {
            x: {
                grid: {
                    // Reducing the number of vertical grid lines:
                    display: false // This will hide all vertical lines. Adjust as needed.
                },
                ticks: {
                    // Hide the labels on the x-axis
                    display: false
                }
            },
            y: {
                type: 'linear',
                display: true,
                position: 'left',
                ticks: {
                    color: "#bbdeffd4",
                    // ... other tick options ...
                },
            },
            y1: {
                type: 'linear',
                display: true,
                position: 'right',
                grid: {
                    drawOnChartArea: false, // only want the grid lines for one axis to show up
                },
                ticks: {
                    color: "#bbdeffd4",
                    // Including a percentage sign in the tooltip
                    callback: function(value, index, ticks) {
                        return value + '%';
                    }
                }
            },
        },
        plugins: {
            legend: {
                labels: {
                    color: '#bbdeffd4',
                    // Set usePointStyle to true to use the point style (circle) for the legend items
                    usePointStyle: true,
                    // Custom styling for the legend boxes
                    boxWidth: 20, // Box width in px
                    boxHeight: 20, // Box height in px
                    padding: 20 // Padding between legend items in px
                }
            },
            tooltip: {
                // position: 'nearest',
                // Set the color of the text for the tooltip
                // bodyFontColor: '#color', // Replace '#color' with your desired color code

                // Custom styling for the tooltip
                // backgroundColor: 'red', // Replace with your desired background color
                // titleColor: 'green', // Replace with your desired title color
                // bodyColor: 'yellow', // Replace with your desired body color
                // bodyFont: {
                //     weight: 'bold'
                // },
                // titleFont: {
                //     weight: 'bold'
                // },
                // borderColor: 'white', // Replace with your desired border color
                // borderWidth: 1,
                usePointStyle: true, // Use the same style as points for the tooltip

                callbacks: {
                    // Modify the label callback to display additional info
                    label: function(context) {
                        let label = context.dataset.label || '';
    
                        if (label) {
                            label += ': ';
                        }
                        if (context.parsed.y !== null) {
                            if (context.datasetIndex === 0) { // Tokens Reserved dataset
                                label += new Intl.NumberFormat('en-US').format(context.parsed.y);
                            } else { // Cumulative Percentage dataset
                                // Append the number of accounts here
                                // For this example, let's just assume the number of accounts is the index + 1
                                label += new Intl.NumberFormat('en-US').format(context.parsed.y) + '%';
                                label += ' (' + (context.dataIndex + 1) + ' accounts)';
                            }
                        }
                        return label;
                    }
                }
            }
        }
    };

    // const totalReservedTokensNum = hodlersData
    // ? hodlersData.reduce((total, hodler) => total + parseFloat(hexNanosToUnitString(hodler.BalanceNanosUint256)), 0)
    // : 0;

    // const totalUSD = data 
    // ? data.AmountRaisedUSDCents / 100
    // : 0;
    
    return (
        <div className={styles.container}>
            {/* <button onClick={fetchHodlers} disabled={isLoading}>
                {isLoading ? 'Loading...' : 'Load All Data'}
            </button> */}

            {hodlersData 
            ? (
                <div className={styles.buttonsContainer}>
                    <button onClick={exportHodlersDataAsJSON}>
                        Export Raw Data
                    </button>
                    <button onClick={exportTableDataAsCSV}>
                        Export as CSV
                    </button>                    
                </div>
            )
            : (
                <button onClick={fetchHodlers} disabled={isLoading}>
                    {isLoading ? 'Loading...' : 'Load All Data'}
                </button>
            )}


            {/* {hodlersData && (
                <SummarySnippet hodlersData={hodlersData} Web3Utils={Web3Utils} />
            )} */}

            {hodlersData && 
                <div className={styles.summary}>
                    <div>Total holders: {totalHolders}</div>
                    <div>Total reserved: {totalReservedTokens}</div>
                </div>
            }

            {hodlersData && (
                <div className={styles.chartContainer}>
                    <Bar options={paretoChartOptions} data={prepareParetoChartData()} />
                </div>
            )}

            
            {preparedData && preparedData?.length > 0 && (
                <div className={styles.resultsContainer}>
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Username / PublicKey</th>
                                <th>Tokens Reserved</th>
                            </tr>
                        </thead>
                        {/* <tbody>
                            {hodlersData.map((hodler, index) => {
                                const tokens = parseFloat(hexNanosToUnitString(hodler.BalanceNanosUint256));
                                // const percentageOfTotal = ((tokens / totalReservedTokensNum) * 100).toFixed(2);
                                const percentageOfTotal = ((tokens / totalReservedTokensNum) * 100);

                                const usdValue = (totalUSD * percentageOfTotal) / 100; // Calculate USD value for each holder

                                return (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>
                                            <a className={styles.userLink} target='_blank' rel="noreferrer" href={`https://wallet.deso.com/?tab=activity&user=${hodler.ProfileEntryResponse?.Username || hodler.HODLerPublicKeyBase58Check}`}>
                                                <div className={styles.avatarFrame}>
                                                    <div className={styles.avatarImage}
                                                        style={{ 
                                                            backgroundImage: `url(${avatarUrl(hodler?.ProfileEntryResponse)})`
                                                        }}
                                                    ></div>
                                                </div>
                                                <div className={styles.username}>
                                                    {hodler.ProfileEntryResponse?.Username || hodler.HODLerPublicKeyBase58Check}    
                                                </div>                                                
                                            </a>
                                        </td>
                                        <td>
                                            { totalUSD > 0 && <div className={styles.usdPerHolder}>+{usdValue.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</div> }        
                                            <div>
                                                {`${tokens.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} 
                                                (${percentageOfTotal.toFixed(2)}%)`}                                                
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody> */}

                        <tbody>
                            {preparedData.map(row => (
                                <tr key={row.index}>
                                    <td>{row.index}</td>
                                    <td>
                                        <a
                                            className={styles.userLink}
                                            target="_blank"
                                            rel="noreferrer"
                                            href={row.profileLink}
                                        >
                                            <div className={styles.avatarFrame}>
                                                <div
                                                    className={styles.avatarImage}
                                                    style={{
                                                        backgroundImage: `url(${row.avatar})`,
                                                    }}
                                                ></div>
                                            </div>
                                            <div className={styles.username}>{row.usernameOrPublicKey}</div>
                                        </a>
                                    </td>
                                    <td>
                                        <div className={styles.usdPerHolder}>+{row.usdValue.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</div>
                                        <div>{row.tokensReserved.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ({`${row.percentageOfTotal}%`})</div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>                        
                    </table>
                </div>
            )}

            {requestError && <div className={styles.error}>Error: {requestError}</div>}
        </div>
    );
};

export default TotalReserved;
